import { useState } from "react";
import axios from "axios";
import { RocketLaunch } from "@phosphor-icons/react";
import { toast } from "@/components/ui/sonner";
import { API } from "@/lib/api";
import { useGenres, GenreOptions } from "@/lib/genres";

// Sticky action bar for the Needs Review queue: one genre for every checked film, then publish.
export const BulkGenreBar = ({ selected, headers, onDone, onClear }) => {
  const [genre, setGenre] = useState("");
  const [busy, setBusy] = useState(false);
  const { groups, label } = useGenres();
  if (!selected.length) return null;
  const apply = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/media/bulk-genre`, { video_ids: selected, genre }, { headers, withCredentials: true });
      toast.success(`${data.updated} film${data.updated === 1 ? "" : "s"} set to ${label(genre)} and pushed live`);
      onDone(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Bulk update failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div
      data-testid="bulk-genre-bar"
      className="sticky bottom-4 z-40 mt-4 flex flex-wrap items-center gap-3 border border-amber/40 bg-[#0d0b06]/95 px-4 py-3 shadow-[0_12px_40px_rgba(0,0,0,0.6)] backdrop-blur-xl"
    >
      <span data-testid="bulk-selected-count" className="font-mono text-[11px] uppercase tracking-[0.15em] text-amber">
        {selected.length} selected
      </span>
      <select
        data-testid="bulk-genre-select"
        value={genre}
        onChange={(e) => setGenre(e.target.value)}
        className="bg-[#111] border border-white/20 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.12em] text-white focus:outline-none focus:border-amber"
      >
        <option value="">Primary genre…</option>
        <GenreOptions groups={groups} />
      </select>
      <button
        type="button"
        data-testid="bulk-apply-btn"
        onClick={apply}
        disabled={!genre || busy}
        className="flex items-center gap-2 bg-amber px-4 py-2 font-mono text-[11px] font-bold uppercase tracking-[0.15em] text-black transition-colors duration-300 hover:bg-amber/80 disabled:opacity-40"
      >
        <RocketLaunch size={15} weight="fill" /> {busy ? "Applying…" : "Apply Genre & Push Live"}
      </button>
      <button type="button" data-testid="bulk-clear-btn" onClick={onClear} className="ml-auto font-mono text-[10px] uppercase tracking-[0.15em] text-white/50 hover:text-white">
        Clear selection
      </button>
    </div>
  );
};
